import { render, staticRenderFns } from "./SummaryInfoGroup.vue?vue&type=template&id=c66d6282&scoped=true&"
import script from "./SummaryInfoGroup.vue?vue&type=script&lang=js&"
export * from "./SummaryInfoGroup.vue?vue&type=script&lang=js&"
import style0 from "./SummaryInfoGroup.vue?vue&type=style&index=0&id=c66d6282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66d6282",
  null
  
)

export default component.exports